export type ResolvedAttachment = {
  kind: 'resolved';
  name: string;
  title: string;
  uri?: string;
};

// Pending attachments must never appear in a sent message — they exist only
// to round-trip Drive picks until a chat exists to mint an ExternalDocument.
export type PendingAttachment = {
  kind: 'pending';
  sourceType: 'GOOGLE_DOCS' | 'NOTION';
  sourceId: string;
  title: string;
  uri?: string;
};

export type ChatAttachment = ResolvedAttachment | PendingAttachment;

export const attachmentKey = (attachment: ChatAttachment): string =>
  attachment.kind === 'resolved'
    ? attachment.name
    : `pending:${attachment.sourceId}`;
